var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.8327 7.00033C12.8327 10.2203 10.2193 12.8337 6.99935 12.8337C3.77935 12.8337 1.16602 10.2203 1.16602 7.00033C1.16602 3.78033 3.77935 1.16699 6.99935 1.16699C10.2193 1.16699 12.8327 3.78033 12.8327 7.00033Z","stroke":"#A7A5A6","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9.1632 8.85503L7.35487 7.77586C7.03987 7.58919 6.7832 7.14003 6.7832 6.77253V4.38086","stroke":"#A7A5A6","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Clock.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
